import { DateInputControl, GreyGrey0 } from '@sequencehq/core-components'
import { formatISODate } from '@sequencehq/utils'
import { useCallback, useMemo } from 'react'

type Props = {
  accountingDate?: string
  onChange: (date: string) => void
  inputWidth?: string
  'data-testid'?: string
  openOnMount?: boolean
  disabled?: boolean
}

export const CreditNoteAccountingDatePicker = ({
  accountingDate,
  onChange,
  inputWidth,
  'data-testid': dataTestId,
  openOnMount = false,
  disabled = false
}: Props) => {
  const handleChange = useCallback(
    (newDate: Date | null) => {
      if (newDate) {
        onChange(formatISODate(newDate))
      }
    },
    [onChange]
  )

  const popoverTestId = useMemo(
    () => (dataTestId ? `${dataTestId}.popover` : undefined),
    [dataTestId]
  )

  return (
    <DateInputControl
      inputProps={{
        height: '32px',
        _hover: { background: GreyGrey0 },
        pl: '8px',
        fontSize: '13px',
        width: inputWidth,
        'data-testid': dataTestId,
        isDisabled: disabled
      }}
      value={accountingDate ? new Date(accountingDate) : new Date()}
      onChange={handleChange}
      minDate={null}
      maxDate={null}
      openOnMount={openOnMount}
      disabled={disabled}
      popoverTestId={popoverTestId}
    />
  )
}
